import React, { useEffect, useState } from "react";
import { Button, Form, Icon, Modal } from "antd";
import _ from "lodash";
import { downloadInstallerAPI } from "../../services/users-service";

const INSTALLERS = {
    "InteleViewerServiceInstaller": "InteleViewerServiceInstaller.zip",
    "PhilipsSpeechMikeInstaller": "PhilipsSpeechMikeInstaller.zip",
    "PhilipsSpeechMikeServiceInstaller": "PhilipsSpeechMikeServiceInstaller.zip",
    "InteleviewerInstaller": "InteleviewerInstaller.zip"
};

const InstallerModal = ({ visible, authUser, onCancel }) => {
    const [downloading, setDownloading] = useState([]);

    useEffect(() => {}, [downloading]);

    const handleInstallerDownload = (installer) => {
        setDownloading(prevState => [...new Set([...prevState, installer])]);
        // Route through Axios API service
        downloadInstallerAPI(installer, onComplete);
    };

    const onComplete = (installerName) => {
        setDownloading(prevState => prevState.filter(e => e !== installerName));
    };

    return (
        <Modal 
            title="Installer"
            visible={visible}
            onCancel={onCancel}
            footer={null}
            maskClosable={false}
            className="cutom-installer-modal custom-login-body"
        >
            {authUser.role !== 'ROLE_TYP' && (
                <Button 
                    type="primary"
                    size="default"
                    loading={downloading.includes(INSTALLERS.InteleViewerServiceInstaller)}
                    onClick={_.debounce(() => { handleInstallerDownload(INSTALLERS.InteleViewerServiceInstaller); }, 1000)}
                >
                    {downloading.includes(INSTALLERS.InteleViewerServiceInstaller) 
                        ? 'Downloading' 
                        : "Download Multipacs Radiscan Service"
                    }
                    <Icon type="download" />
                </Button>
            )}

            <Button 
                type="primary"
                size="default"
                loading={downloading.includes(INSTALLERS.InteleviewerInstaller)}
                onClick={_.debounce(() => { handleInstallerDownload(INSTALLERS.InteleviewerInstaller); }, 1000)}
            >
                {downloading.includes(INSTALLERS.InteleviewerInstaller) 
                    ? "Downloading" 
                    : "Download Inteleviewer Installer"
                }
                <Icon type="download" />
            </Button>
        </Modal>
    );
};

export default InstallerModal;